import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import clinicService from '../../../../../services/clinic.service';
import { toast } from 'react-toastify';

const ClinicOverviewForm = ({ clinicinfo, getClinicData }) => {
    const { register, handleSubmit, formState: { errors } } = useForm({
        defaultValues: clinicinfo,
    });
    const [clinic, setClinic] = useState(clinicinfo);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setClinic(clinicinfo);
    }, [clinicinfo, getClinicData]);

    const cleanPhoneNumber = (phoneNumber) => {
        return phoneNumber.replace(/\D/g, '');
    };

    const onSubmit = (data) => {
        setIsLoading(true);
        const newData = {
            id: data.id,
            name: data.name,
            email: data.email,
            phone: cleanPhoneNumber(data.phone),
            sms: cleanPhoneNumber(data.sms),
            logo: data.logo,
            signature: data.signature,
            website: data.website,
            clinicType: data.clinicType,
            street: data.street,
            city: data.city,
            postalCode: data.postalCode,
            province: data.province,
            country: data.country,
        };
        clinicService
            .updateClinic(clinic.id, newData)
            .then(() => {
                setIsLoading(false);
                toast.success('Modified Successfully', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
                getClinicData();
            })
            .catch((err) => {
                setIsLoading(false);
                toast.error(err.response.data.message, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            });
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-3">
                <label htmlFor="clinicType" className="notifications-form-label">
                    Type
                </label>
                <select className="form-select form-select-sm" id="clinicType" {...register('clinicType', { required: true })}>
                    <option value="EYECONX">EYECONX</option>
                    <option value="SMS_GATEWAY">SMS GATEWAY</option>
                    <option value="ADMIN">ADMIN</option>
                </select>
            </div>

            <div className="mb-3">
                <label htmlFor="name" className="notifications-form-label">
                    Name
                </label>
                <input
                    type="text"
                    id="name"
                    className="form-control form-control-sm"
                    placeholder="Clinic Name"
                    {...register('name', { required: true })}
                />
                {errors.name && <div className="text-danger small mt-1">Name is required</div>}
            </div>

            <div className="mb-3">
                <label htmlFor="email" className="notifications-form-label">
                    Email
                </label>
                <input
                    type="text"
                    id="email"
                    className="form-control form-control-sm"
                    placeholder="Clinic Email"
                    {...register('email', { required: true })}
                />
                {errors.email && <div className="text-danger small mt-1">Email is required</div>}
            </div>

            <div className="mb-3">
                <label htmlFor="phone" className="notifications-form-label">
                    Phone
                </label>
                <input
                    type="text"
                    id="phone"
                    className="form-control form-control-sm"
                    placeholder="Clinic Phone"
                    {...register('phone', { required: true })}
                />
                {errors.phone && <div className="text-danger small mt-1">Phone is required</div>}
            </div>

            <div className="mb-3">
                <label htmlFor="sms" className="notifications-form-label">
                    SMS
                </label>
                <input
                    type="text"
                    id="sms"
                    className="form-control form-control-sm"
                    placeholder="Clinic SMS"
                    {...register('sms', { required: true })}
                />
                {errors.sms && <div className="text-danger small mt-1">SMS is required</div>}
            </div>

            <div className="mb-3">
                <label htmlFor="signature" className="notifications-form-label">
                    Signature
                </label>
                <input
                    type="text"
                    id="signature"
                    className="form-control form-control-sm"
                    placeholder="Clinic Signature"
                    {...register('signature', { required: true })}
                />
                {errors.signature && <div className="text-danger small mt-1">Signature is required</div>}
            </div>

            <div className="mb-3">
                <label htmlFor="logo" className="notifications-form-label">
                    Logo URL
                </label>
                <input
                    type="text"
                    id="logo"
                    className="form-control form-control-sm"
                    placeholder="Clinic Logo URL"
                    {...register('logo')}
                />
            </div>

            <div className="mb-3">
                <label htmlFor="website" className="notifications-form-label">
                    Website
                </label>
                <input
                    type="text"
                    id="website"
                    className="form-control form-control-sm"
                    placeholder="Clinic Website"
                    {...register('website', { required: true })}
                />
                {errors.website && <div className="text-danger small mt-1">Website is required</div>}
            </div>

            <div className="d-flex pt-2 border-top">
                <button type="submit" className="btn btn-success btn-sm" disabled={isLoading}>
                    {isLoading ? (
                        <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    ) : (
                        <i className="bi bi-floppy me-1"></i>
                    )}
                    Save
                </button>
            </div>
        </form>
    );
};

export default ClinicOverviewForm;
